import { PropsWithChildren } from 'react';

import Button from '~components/Button/Button';
import Trustpilot from '~components/Trustpilot/Trustpilot';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';
import BBB from '~images/inline/BBB.inline.svg';

interface IProps {
    stateName?: string | undefined;
    planYear?: string | undefined;
    zipFormHeading?: string | undefined;
    zipFormMainCtaCopy?: string | undefined;
    zipFormSecondaryCtaCopy?: string | undefined;
    zipFormQaValue?: string;
    pageFilter?: string;
}

const ZipWithStepperLegacy = ({
    stateName = 'your state',
    planYear = '',
    zipFormHeading = '',
    zipFormMainCtaCopy = '',
    zipFormSecondaryCtaCopy = '',
    zipFormQaValue = '',
    pageFilter,
}: PropsWithChildren<IProps>) => {
    const heading = zipFormHeading || `Find ${planYear} Medicare Advantage plans in ${stateName}`;
    return (
        <>
            <section className="hero-paid-search-legacy-style">
                <h2 className="text-center lg:text-start">{heading}</h2>
                <div className="rounded-lg flex justify-center">
                    <div className="max-w-screen-xs md:max-w-screen-xl w-full">
                        <div className="">
                            <ZipForm
                                buttonTitle="Help me find a plan"
                                buttonTitleMobile="Help me choose"
                                buttonWaLink="Hero Guided Flow: help me find a plan"
                                qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                                opts={{
                                    btnStyle: 'primary',
                                    useWideLayout: true,
                                }}
                                redirect={{
                                    toUrl: process.env.GATSBY_EHIM_STEPPER_URL,
                                    delay: 500,
                                }}
                            />
                        </div>

                        <div className="mt-6 md:mt-0">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12 md:col-span-12 lg:col-span-6 lg:col-start-4">
                                    <Button
                                        islink
                                        forceATag
                                        href={process.env.GATSBY_EHMP_URL}
                                        data-wa-link="Hero Stepper: compare plan"
                                        styletype="secondary"
                                        data-filter={pageFilter}
                                    >
                                        See plans in my area
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3 md:hidden flex justify-center">
                    <div className="mr-6">
                        <div className="norton-placeholder" id="DigiCertClickID_onwANETs_6"></div>
                    </div>
                    <div>
                        <BBB width={100} height={70} />
                    </div>
                </div>
            </section>
            <div className="py-6 lg:py-10">
                <Trustpilot size="newthin" />
            </div>
        </>
    );
};

export default ZipWithStepperLegacy;
